export default __webpack_public_path__ + "static/media/nucleo-icons.01ebecaf.svg";